import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopBar'),_c('LeftToolbar'),_c(VMain,[_c('div',{staticClass:"view"},[_c('div',{staticClass:"main-box"},[_c('router-view',{key:_vm.$route.fullPath + _vm.reloadKey})],1)])]),_c('Loading'),_c('Notifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }